<template>
    <div class="templete_box">
        <div class="financeBox">
            <img class="financeImg" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/pc/%E5%8A%A0%E5%B7%A5%E7%B3%BB%E7%BB%9F%402x.png" alt="">
        </div>
    </div>
</template>
<style scoped lang="scss">
.templete_box{text-align: left;}
.financeBox{overflow-y: auto;height: 100%;padding-bottom: 40px;background-color: #fff;}
.financeImg{width: 780px;}

</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                
            }
        },
        created(){
           
        },
        methods:{
          
        },
        watch:{
            
        }
    }
</script>
